import { styled } from '../../utils/styled';
import { Stack } from '../Stack';

export const StyledStack = styled(Stack)`
  display: flex;
  align-items: center;
`;
